import React, { useEffect, useState } from 'react';
import '../styles/MemberDetails.css';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import SideBar from '../components/SideBar';
import '../styles/WalletPage.css';
import noRecordsImg from "../assets/images/no-record-found 3.png";
import '../styles/CustomerUnitsTransactionHistory.css';

function RetailerUnitsTransactionHistory() {
    const location = useLocation();
    const retail = location.state?.retail; // get customer from navigation
    const navigate = useNavigate();

    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(true);

    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 10;

    const goToWallet = () => navigate('/retail-wallet-details', { state: { retail } });
    const goToRequestHistory = () => navigate('/retail-cash-request-history', { state: { retail } });
    const goToRetailDetails = () => navigate('/retailer-shop-details', { state: { retail } });

    useEffect(() => {
        // Simulate short delay (optional)
        setTimeout(() => {
            if (retail?.transactions) {
                setTransactions(retail.transactions);
            }
            setLoading(false);
        }, 300); // small delay just for UI effect
    }, [retail]);

    const formatDate = (dateString) => {
        if (!dateString) return "N/A";
        try {
            return new Date(dateString).toLocaleDateString("en-GB", {
                year: "numeric",
                month: "short",
                day: "numeric"
            });
        } catch {
            return dateString;
        }
    };

    // Convert Units → Euros (1% of amount)
    // const convertToEuro = (amount) => {
    //     const numericAmount = parseFloat(amount);
    //     if (isNaN(numericAmount)) return "€0.00";
    //     const euroValue = Math.abs(numericAmount * 0.01).toFixed(2);
    //     return `€ ${euroValue}`;
    // };

    // Pagination logic
    const totalPages = Math.ceil(transactions.length / rowsPerPage);
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentTransactions = transactions.slice(indexOfFirstRow, indexOfLastRow);


    if (!retail) return <p>No retailer selected.</p>;

    return (
        <div className="member-details-layout">
            <SideBar />
            <div className="member-details-main">
                {/* Header */}
                <div className="details-header">
                    <h2>Retailer Shop Details</h2>
                    <p>You can edit your details to update your profile</p>
                </div>

                {/* Breadcrumb */}
                <div className="breadcrumb">
                    <Link to="/dashboard" className="breadcrumb-link">Home</Link>
                    <span className="breadcrumb-separator">{">"}</span>
                    <Link to="/manage-retailer" className="breadcrumb-link">Manage Retailer Shop</Link>
                    <span className="breadcrumb-separator">{">"}</span>
                    <span className="breadcrumb-current">Retailer Shop Details</span>
                </div>

                {/* Top buttons */}
                <div className="top-bar">
                    <div className="top-buttons">
                        <button className="tab-btn" onClick={goToRetailDetails}>Personal Details</button>
                        <button className="tab-btn active" onClick={goToWallet}>Wallet Details</button>
                        <button className="tab-btn" onClick={goToRequestHistory}>Cash Request History</button>
                    </div>
                </div>

                {/* Transaction Section */}
                <div className="transaction-container">
                    <div className="transaction-header">
                        <h2 className="title">Transaction History</h2>
                        <div className="transaction-count">
                            {transactions.length} {transactions.length === 1 ? "Transaction" : "Transactions"}
                        </div>
                    </div>

                    <div className="transaction-content">
                        {loading ? (
                            <div className="loading-container">
                                <div className="loading-spinner"></div>
                                <p>Loading transactions...</p>
                            </div>
                        ) : currentTransactions.length > 0 ?(
                            <>
                            <div className="transaction-table-container">
                                <div className="table-header">
                                    <div className="cell date">Date</div>
                                    <div className="cell type">Type</div>
                                    <div className="cell description">Description</div>
                                    <div className="cell units">Amount</div>
                                </div>
                                <div className="table-body">
                                    {currentTransactions.map((txn, idx) => (
                                        <div className="table-row" key={idx}>
                                            <div className="cell date" data-label="Date">{formatDate(txn.date)}</div>
                                            <div className="cell type" data-label="Type">
                                                <span className={`type-badge ${txn.transaction_type.toLowerCase()}`}>
                                                    {txn.transaction_type}
                                                </span>
                                            </div>
                                            <div className="cell description" data-label="Description">{txn.description || 'No description'}</div>
                                            <div className={`cell units ${txn.amount < 0 ? "negative" : "positive"}`} data-label="Amount">
                                                {txn.amount < 0 ? "-" : "+"}{Math.abs(txn.amount)} Units
                                                {/* Units display */}
                                                {/* {txn.amount < 0 ? "-" : "+"} */}
                                                {/* {Math.abs(txn.amount)} Units */}
                                                {/* <br /> */}
                                                {/* Euro display */}
                                                {/* <span className="euro-amount"> */}
                                                    {/* (≈ {convertToEuro(txn.amount)}) */}
                                                    {/* ({convertToEuro(txn.amount)}) */}
                                                {/* </span> */}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            </>
                        ) : (
                            <div className="no-records">
                                <img src={noRecordsImg} alt="No records" />
                                <h3>No transactions yet</h3>
                                <p>Please make a purchase using your QR code at partner shops to earn TopCoin.</p>
                            </div>
                        )}
                    </div>

                    <div className="transaction-pagination">
                        <button className="page-btn" onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}>
                        &lt;
                        </button>
                        {Array.from({ length: totalPages }, (_, i) => (
                        <button
                            key={i}
                            className={`page-btn ${currentPage === i + 1 ? "active" : ""}`}
                            onClick={() => setCurrentPage(i + 1)}
                        >
                            {i + 1}
                        </button>
                        ))}
                        <button className="page-btn" onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}>
                        &gt;
                        </button>
                    </div>

                    <div className="back-link">
                        <Link to="/retail-wallet-details" state={{ retail }}>Back to Wallet &lt;&lt;</Link>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default RetailerUnitsTransactionHistory;
